import { gql } from '@apollo/client';
import { useQuery, UseQueryResult } from 'react-query';
import { graphqlClient } from 'bk-web-app';
import { DataSource } from '../types/DataSource';

const DATA_SOURCES_QUERY = gql`
  query DataSources {
    dataSources {
      id
      name
    }
  }
`;

const get = async (apiUrl: string): Promise<DataSource[]> => {
  if (!apiUrl) throw new Error('API URL is not configured');

  const response: Response = await fetch(`${apiUrl}/data-sources`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch data sources');
  }

  return (await response.json()) as DataSource[];
};

const getViaGraphQL = async (): Promise<DataSource[]> => {
  const { data } = await graphqlClient.query({
    query: DATA_SOURCES_QUERY,
    context: { useV2: true },
  });
  return data.dataSources.map((ds: { id: string; name: string }) => ({
    dataSourceId: ds.id,
    name: ds.name,
  }));
};

export const useFetchDataSources = ({ useGraphQL = false } = {}): UseQueryResult<DataSource[]> => {
  const apiUrl = window.BENCH?.auApi?.FIND_GLOBAL_SERVICES_API_URL || '';

  return useQuery({
    queryKey: ['getDataSources', useGraphQL],
    queryFn: () => (useGraphQL ? getViaGraphQL() : get(apiUrl)),
  });
};
